import React from "react";
import { InfoBox, InfoBoxLayoutType } from "./InfoBox";
import { InfoboxesOptionsType } from "@/types/ModuleOptionsType";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";
import { Modul_Infoboxen } from "@/wp/types/acf-module-types";
import styles from "./InfoBox.module.scss";
import { InfoBoxElementType, TextInfoBoxType } from "../InfoBoxesModule";

type TextInfoboxElementType = Exclude<
  Modul_Infoboxen["infoboxes"]["elements"],
  false
>;

type InfoBoxesBaseProps = {
  infoBoxOptions: InfoboxesOptionsType;
  extraClass?: string;
  itemWidth: Record<Breakpoint, string>;
  show_cardbox: boolean;
  show_divider: boolean;
  heading_level: number;
  layout?: InfoBoxLayoutType;
};

type InfoBoxesProps = InfoBoxesBaseProps &
  (
    | {
        elements: InfoBoxElementType[];
        type: "infobox";
      }
    | {
        elements: TextInfoboxElementType;
        type: "textInfobox";
      }
  );

export const InfoBoxes = ({
  elements,
  infoBoxOptions,
  extraClass,
  itemWidth,
  show_cardbox,
  show_divider,
  heading_level,
  layout = "v1",
  type,
}: InfoBoxesProps) => {
  return (
    <div className={`${styles["infoboxes"]} columns is-multiline is-centered`}>
      {elements.map((element, index) => {
        switch (type) {
          case "textInfobox":
            return (
              <InfoBox
                key={index}
                type="textInfobox"
                textInfobox={element as TextInfoBoxType}
                extraClass={`${extraClass}`}
                infoBoxOptions={infoBoxOptions}
                itemWidth={itemWidth}
                show_cardbox={show_cardbox}
                show_divider={show_divider}
                heading_level={heading_level}
                layout={layout}
              />
            );
          case "infobox":
            return (
              <InfoBox
                key={index}
                type="infobox"
                infobox={element}
                extraClass={`${extraClass}`}
                infoBoxOptions={infoBoxOptions}
                itemWidth={itemWidth}
                show_cardbox={show_cardbox}
                show_divider={show_divider}
                heading_level={heading_level}
                layout={layout}
              />
            );
        }
      })}
    </div>
  );
};
